module.exports = __webpack_public_path__ + "static/img/050203.90758733.png";